//
//  EditDependant Component
//  CXA Apollo
//
//  Created on 09/01/2017.
//  Copyright (c) 2017 CXA. All rights reserved.
//

import React from "react";
import {
  loadDependantFormData,
  saveDependant,
  resetEditDependantForm,
} from "../../actions/dependantActions";

// Redux
import { connect } from "react-redux";
import AddEditDependantForm from "./AddEditDependantForm";
import { Loader } from "cxa-components";
import moment from "moment";
import { injectIntl, intlShape } from "react-intl";

class AddEditDependantPage extends React.Component {
  componentDidMount() {
    const { login, match: { params } } = this.props;
    const employeeKey = parseInt(login.user.employee.objectId);
    const dependantId = parseInt(params.dependantId || "0");

    this.props.loadDependantFormData(dependantId, employeeKey);
  }

  componentWillUpdate(nextProps) {
    const { push, formSubmitSucceeded, formSubmitFailed } = nextProps;
    if (formSubmitSucceeded) {
      this.props.resetEditDependantForm();
      push("/userProfile");
    }
  }

  render() {
    const {
      formDataLoaded,
      formSubmitFailed,
      error,
      saveDependant,
    } = this.props;

    return formDataLoaded
      ? <div className="o-layout">
          <div className="o-layout__item u-1/2@desktop">
            <AddEditDependantForm
              submitDependant={this.props.saveDependant}
              {...this.props}
            />
          </div>
        </div>
      : <Loader />;
  }
}

const mapStateToProps = (
  {
    login,
    dependants: {
      fields,
      formValues,
      dependant,
      formDataLoaded,
      formSubmitSucceeded,
      formSubmitFailed,
      error,
    },
  },
  ownProps,
) => {
  const { goBack, match: { params: { dependantId } }, intl } = ownProps;

  function translateDependant(dependant) {
  
    return Object.fromEntries(
      Object.entries(dependant).map(([key, value]) => [
        key,
        intl.formatMessage({ id: String(value), defaultMessage: String(value) }),
      ])
    );
  }

  let initialValues;
  const defaultValues = {
    String: "",
    //"Date": moment().startOf("day"),
    DropDown: "",
  };

  if (dependantId) {
    initialValues = translateDependant(dependant);
  } else {
    initialValues = fields.reduce(
      (object, field) => ({ ...object, [field.id]: defaultValues[field.type] }),
      {}
    );
  }

  return {
    mode: dependantId ? "edit" : "add",
    dependantId,
    login,
    fields,
    formValues,
    dependant,
    formDataLoaded,
    formSubmitSucceeded,
    formSubmitFailed,
    error,
    initialValues,
    cancel: goBack,
  };
};

AddEditDependantPage.propTypes = {
  intl: intlShape.isRequired,
};

const mapDispatchToProps = dispatch => ({
  loadDependantFormData: (dependantId, employeeKey) =>
    dispatch(loadDependantFormData(dependantId, employeeKey)),
  saveDependant: data => dispatch(saveDependant(data)),
  resetEditDependantForm: () => dispatch(resetEditDependantForm()),
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(
  AddEditDependantPage
));



// WEBPACK FOOTER //
// ./components/dependants/AddEditDependantPage.jsx